import { PublicClientApplication, Configuration } from '@azure/msal-browser'
import { graphConfig, isGraphConfigured } from './config'

const msalConfig: Configuration = {
  auth: {
    // When IT hasn't pasted real IDs yet, we use harmless placeholders. The
    // instance is still created + initialized so <MsalProvider> never crashes,
    // but no Graph calls ever run because isGraphConfigured() gates them.
    clientId: graphConfig.clientId || '00000000-0000-0000-0000-000000000000',
    authority: `https://login.microsoftonline.com/${graphConfig.tenantId || 'common'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)

// MSAL v3 requires initialize() before the instance is used, and <MsalProvider>
// (msal-react v2) will call handleRedirectPromise() on mount — which throws if
// the instance is uninitialized. So we ALWAYS initialize (this is a local,
// no-network operation even with placeholder IDs) to keep the app running in
// browser-local mode. We only touch the redirect flow when Graph is configured.
msalInstance
  .initialize()
  .then(() => {
    if (isGraphConfigured()) {
      return msalInstance.handleRedirectPromise()
    }
  })
  .catch((err) => {
    // Never let an auth hiccup take down the intranet — local mode still works.
    console.warn(
      'MSAL initialization skipped/failed (local mode is fine):',
      err,
    )
  })
